import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-class-achievement-scale-map',
  templateUrl: './class-achievement-scale-map.component.html',
  styleUrls: ['./class-achievement-scale-map.component.css']
})
export class ClassAchievementScaleMapComponent implements OnInit {

  Submitted:boolean=false;
  ExamClassAchievementScaleMapList:any;
  ClassList:any;

  constructor(private examservice:ExamService,private LookupService: LookupService, private globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

    ExamClassAchievementScaleMapModel = {
      ExamClassAchievementScaleMapID: 0,
      ClassID: 0,
      IsActive:''

  };

  SaveExamClassAchievementScaleMap() {
  
   
    this.spinnerService.show();
    this.examservice.SaveExamClassAchievementScaleMap(JSON.stringify(this.ExamClassAchievementScaleMapList),JSON.stringify(this.ExamClassAchievementScaleMapModel)).subscribe((data: any) => {
      if (data.webResponse.Status) {
      
      this.spinnerService.hide();
      }
      this.globalHelper.CheckActionStatus(data);
  
    });
  };

  GetClass(){
    this.LookupService.GetLookupsList('ClassExamFormat1Grading', '').subscribe((data: any) => {
        this.ClassList = data.LookupItems;
    });
};

GetExamClassAchievementScaleMap() {
  
  this.spinnerService.show();
  this.examservice.GetExamClassAchievementScaleMap(this.ExamClassAchievementScaleMapModel.ClassID).subscribe((data: any) => {
      this.ExamClassAchievementScaleMapList = data.ExamClassAchievementScaleMapList;
      for (var i = 0; i < this.ExamClassAchievementScaleMapList.length; i++) {
          if (this.ExamClassAchievementScaleMapList[i].IsActive) {
              this.ExamClassAchievementScaleMapModel.IsActive = this.ExamClassAchievementScaleMapList[i].IsActive;
          }
      }
      this.spinnerService.hide();
    
      this.globalHelper.CheckActionStatus(data);
  });
};


  ngOnInit() {
    this.GetClass();
  }

}
